function calculateDaysDifference(startDate, endDate){
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffInMilliseconds = start - end;
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
    return Math.abs(diffInDays);
}
function calculateDaysDifferenceWithoutAbs(startDate, endDate){
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffInMilliseconds = start - end;
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
    return diffInDays;
}
export { calculateDaysDifference, calculateDaysDifferenceWithoutAbs }